export const UPDATE_CAMPAIGN_LIST = "UPDATE_CAMPAIGN_LIST";
